import { Box } from "@mui/material";

// Create will be added at a later time
export const UsersCreate = () => (
  <Box sx={{ display: "flex" }}>
    <Box component="main" sx={{ flexGrow: 1 }}>
      <Box sx={{ width: "100%", p: 5 }}>Coming Soon</Box>
    </Box>
  </Box>
);
